import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=7e8d7044&scoped=true&"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=js&"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=7e8d7044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d7044",
  null
  
)

export default component.exports